"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmaConfig = void 0;
var FirmaConfig = /** @class */ (function () {
    function FirmaConfig(chainID, rpcAddress, restApiAddress, ipfsNodeAddress, ipfsNodePort, ipfsWebApiAddress, hdPath, prefix, denom, defaultFee, defaultGas, isShowLog) {
        this.chainID = chainID;
        this.rpcAddress = rpcAddress;
        this.restApiAddress = restApiAddress;
        this.ipfsNodeAddress = ipfsNodeAddress;
        this.ipfsNodePort = ipfsNodePort;
        this.ipfsWebApiAddress = ipfsWebApiAddress;
        this.hdPath = hdPath;
        this.prefix = prefix;
        this.denom = denom;
        this.defaultFee = defaultFee;
        this.defaultGas = defaultGas;
        this.isShowLog = isShowLog;
    }
    FirmaConfig.DevNetConfig = {
        chainID: "roma-1",
        rpcAddress: "http://192.168.20.113:26657",
        restApiAddress: "http://192.168.20.113:1317",
        ipfsNodeAddress: "http://192.168.20.120",
        ipfsNodePort: 5001,
        ipfsWebApiAddress: "http://192.168.20.120:8080",
        hdPath: "m/44'/7777777'/",
        prefix: "firma",
        denom: "ufct",
        defaultFee: 20000,
        defaultGas: 200000,
        isShowLog: true,
    };
    FirmaConfig.TestNetConfig = {
        chainID: "imperium-4",
        rpcAddress: "https://lcd-testnet.firmachain.dev:26657",
        restApiAddress: "https://lcd-testnet.firmachain.dev:1317",
        ipfsNodeAddress: "https://ipfs-dev.firmachain.dev",
        ipfsNodePort: 5001,
        ipfsWebApiAddress: "https://ipfs-dev.firmachain.dev",
        hdPath: "m/44'/7777777'/",
        prefix: "firma",
        denom: "ufct",
        defaultFee: 20000,
        defaultGas: 200000,
        isShowLog: true,
    };
    FirmaConfig.MainNetConfig = {
        chainID: "colosseum-1",
        rpcAddress: "https://lcd-mainnet.firmachain.dev:26657",
        restApiAddress: "https://lcd-mainnet.firmachain.dev:1317",
        ipfsNodeAddress: "https://ipfs-dev.firmachain.dev",
        ipfsNodePort: 5001,
        ipfsWebApiAddress: "https://ipfs-dev.firmachain.dev",
        hdPath: "m/44'/7777777'/",
        prefix: "firma",
        denom: "ufct",
        defaultFee: 30000,
        defaultGas: 300000,
        isShowLog: false,
    };
    return FirmaConfig;
}());
exports.FirmaConfig = FirmaConfig;
